import { showInfo } from '../../../common/A1Alert/A1Alert';
import Api from '../../../helpers/Api';

export const SET_JOURNALISTS_DATA = 'SET_JOURNALISTS_DATA';
const setJournalistsData = (journalistsData) => ({
    type: SET_JOURNALISTS_DATA,
    journalistsData,
});

export const SET_IS_LOADING_DATA = 'SET_IS_LOADING_DATA';
const setIsLoadingData = (isLoading) => ({
    type: SET_IS_LOADING_DATA,
    isLoading,
});

export const SET_IS_LOADING_NEWS = 'SET_IS_LOADING_NEWS';
const setIsLoadingNews = (isLoading) => ({
    type: SET_IS_LOADING_NEWS,
    isLoading,
});

export const ADD_JOURNALIST_NEWS = 'ADD_JOURNALIST_NEWS';
const addJournalistNews = (id, news) => ({
    type: ADD_JOURNALIST_NEWS,
    id,
    news,
});

export const getJournalistsData = () => (dispatch) => {
// get all the journalist data from the api and set it in the store


    const query = 'api/v1/getJournalistsData';

    return Api.progressGet(dispatch, query)
        .then((json) => {
            if (json.status !== 'success') {
                throw 'error from server';
            } else {
                dispatch(setJournalistsData(json.data));

                dispatch(setIsLoadingData(false));
            }
        }).catch((err) => {
            // eslint-disable-next-line no-console
            console.error(err);

            dispatch(setIsLoadingData(false));
        });
};


export const getJournalistNews = (id, num = 10, init = 0) => (dispatch) => {
    // This function will get num news from the given journalist (id) with an offset of init
    const query = `api/v1/getJournalistNews/${id}/${num}/${init}`;

    // set isLoading to true
    dispatch(setIsLoadingNews(true));

    return Api.progressGet(dispatch, query)
        .then((json) => {
            dispatch(setIsLoadingNews(false));

            if (json.status !== 'success') {
                throw `error from server: ${json.message}`;
            } else {
                if (json.message === 'no more news') {
                    showInfo('Não há mais notícias.');
                }

                dispatch(addJournalistNews(id, json.data));
            }
        }).catch((err) => {
            // eslint-disable-next-line no-console
            console.error(err);
        });
};
